import type {
  CharacterAwarenessDaysCalendarPageQuery,
  CharacterAwarenessDaysCalendarPageQueryVariables,
  CalendarByYearV5QueryVariables,
  CalendarByYearV5Query,
  CalendarPage,
} from '@edwin-group/cj-graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_CALENDAR_BY_YEAR_V5, QUERY_CHARACTER_AWARENESS_DAYS_CALENDAR_PAGE_V5 } from '@edwin-group/cj-graphql';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<CharacterAwarenessDaysCalendarPageQuery, CharacterAwarenessDaysCalendarPageQueryVariables>({
      query: QUERY_CHARACTER_AWARENESS_DAYS_CALENDAR_PAGE_V5,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.calendarPage as CalendarPage,
    error,
  };
};

export const getCalendar = async () => {
  const apolloClient = initializeApollo();

  const currentYear = new Date().getFullYear();

  const { data, error } = await requestHandler(
    apolloClient.query<CalendarByYearV5Query, CalendarByYearV5QueryVariables>({
      query: QUERY_CALENDAR_BY_YEAR_V5,
      variables: {
        year: currentYear,
      },
      fetchPolicy: 'network-only',
    }),
  );

  const calendar = data?.calendars?.nodes?.[0];

  return { data: calendar, error };
};
